
export const CLIENT_DETAILS_REQUEST_START: string = 'clientManagement/clientDetails/REQUEST_LOADING';
export const CLIENT_DETAILS_REQUEST_FAIL: string = 'clientManagement/clientDetails/REQUEST_FAIL';
export const CLIENT_DETAILS_REQUEST_SUCCESS: string = 'clientManagement/clientDetails/REQUEST_SUCCESS';

export const VBAN_DETAILS_REQUEST_START: string = 'clientManagement/vbanDetails/REQUEST_LOADING';
export const VBAN_DETAILS_REQUEST_FAIL: string = 'clientManagement/vbanDetails/REQUEST_FAIL';
export const VBAN_DETAILS_REQUEST_SUCCESS: string = 'clientManagement/vbanDetails/REQUEST_SUCCESS';
